/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVmMongo } from '../models/custom-result-of-audit-vm-mongo';
import { CustomResultOfGetOrganizationTransactionByIdDto } from '../models/custom-result-of-get-organization-transaction-by-id-dto';
import { CustomResultOfTransactionsWithPaginationDto } from '../models/custom-result-of-transactions-with-pagination-dto';
import { LastLimitedTransactionDto } from '../models/last-limited-transaction-dto';
import { organizationTransactionsCreateTransactionForOrganizationGet } from '../fn/organization-transactions/organization-transactions-create-transaction-for-organization-get';
import { OrganizationTransactionsCreateTransactionForOrganizationGet$Params } from '../fn/organization-transactions/organization-transactions-create-transaction-for-organization-get';
import { organizationTransactionsCreateTransactionForOrganizationPost } from '../fn/organization-transactions/organization-transactions-create-transaction-for-organization-post';
import { OrganizationTransactionsCreateTransactionForOrganizationPost$Params } from '../fn/organization-transactions/organization-transactions-create-transaction-for-organization-post';
import { organizationTransactionsGetCurrentOrganizationLastLimitedTransactions } from '../fn/organization-transactions/organization-transactions-get-current-organization-last-limited-transactions';
import { OrganizationTransactionsGetCurrentOrganizationLastLimitedTransactions$Params } from '../fn/organization-transactions/organization-transactions-get-current-organization-last-limited-transactions';
import { organizationTransactionsGetCurrentUserLastLimitedTransactions } from '../fn/organization-transactions/organization-transactions-get-current-user-last-limited-transactions';
import { OrganizationTransactionsGetCurrentUserLastLimitedTransactions$Params } from '../fn/organization-transactions/organization-transactions-get-current-user-last-limited-transactions';
import { organizationTransactionsGetOrganizationTransactionById } from '../fn/organization-transactions/organization-transactions-get-organization-transaction-by-id';
import { OrganizationTransactionsGetOrganizationTransactionById$Params } from '../fn/organization-transactions/organization-transactions-get-organization-transaction-by-id';
import { organizationTransactionsGetOrganizationTransactionsAudit } from '../fn/organization-transactions/organization-transactions-get-organization-transactions-audit';
import { OrganizationTransactionsGetOrganizationTransactionsAudit$Params } from '../fn/organization-transactions/organization-transactions-get-organization-transactions-audit';
import { organizationTransactionsGetOrganizationTransactionsByOrganizationIdWithPagination } from '../fn/organization-transactions/organization-transactions-get-organization-transactions-by-organization-id-with-pagination';
import { OrganizationTransactionsGetOrganizationTransactionsByOrganizationIdWithPagination$Params } from '../fn/organization-transactions/organization-transactions-get-organization-transactions-by-organization-id-with-pagination';
import { organizationTransactionsGetOrganizationTransactionsByUserIdWithPagination } from '../fn/organization-transactions/organization-transactions-get-organization-transactions-by-user-id-with-pagination';
import { OrganizationTransactionsGetOrganizationTransactionsByUserIdWithPagination$Params } from '../fn/organization-transactions/organization-transactions-get-organization-transactions-by-user-id-with-pagination';
import { organizationTransactionsGetOrganizationTransactionsWithPagination } from '../fn/organization-transactions/organization-transactions-get-organization-transactions-with-pagination';
import { OrganizationTransactionsGetOrganizationTransactionsWithPagination$Params } from '../fn/organization-transactions/organization-transactions-get-organization-transactions-with-pagination';
import { organizationTransactionsGetResellerOrganizationTransactionWithPagination } from '../fn/organization-transactions/organization-transactions-get-reseller-organization-transaction-with-pagination';
import { OrganizationTransactionsGetResellerOrganizationTransactionWithPagination$Params } from '../fn/organization-transactions/organization-transactions-get-reseller-organization-transaction-with-pagination';

@Injectable({ providedIn: 'root' })
export class OrganizationTransactionsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `organizationTransactionsCreateTransactionForOrganizationGet()` */
  static readonly OrganizationTransactionsCreateTransactionForOrganizationGetPath = '/OrganizationTransactions/CreateTransactionForOrganization';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationTransactionsCreateTransactionForOrganizationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationTransactionsCreateTransactionForOrganizationGet$Response(params?: OrganizationTransactionsCreateTransactionForOrganizationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return organizationTransactionsCreateTransactionForOrganizationGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationTransactionsCreateTransactionForOrganizationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationTransactionsCreateTransactionForOrganizationGet(params?: OrganizationTransactionsCreateTransactionForOrganizationGet$Params, context?: HttpContext): Observable<Blob> {
    return this.organizationTransactionsCreateTransactionForOrganizationGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `organizationTransactionsCreateTransactionForOrganizationPost()` */
  static readonly OrganizationTransactionsCreateTransactionForOrganizationPostPath = '/OrganizationTransactions/CreateTransactionForOrganization';

  /**
   * Create OrganizationTransaction.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationTransactionsCreateTransactionForOrganizationPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationTransactionsCreateTransactionForOrganizationPost$Response(params: OrganizationTransactionsCreateTransactionForOrganizationPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return organizationTransactionsCreateTransactionForOrganizationPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create OrganizationTransaction.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationTransactionsCreateTransactionForOrganizationPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationTransactionsCreateTransactionForOrganizationPost(params: OrganizationTransactionsCreateTransactionForOrganizationPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.organizationTransactionsCreateTransactionForOrganizationPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `organizationTransactionsGetOrganizationTransactionsWithPagination()` */
  static readonly OrganizationTransactionsGetOrganizationTransactionsWithPaginationPath = '/OrganizationTransactions/GetOrganizationTransactionsWithPagination';

  /**
   * For each user get OrganizationTransactions with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationTransactionsGetOrganizationTransactionsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationTransactionsGetOrganizationTransactionsWithPagination$Response(params: OrganizationTransactionsGetOrganizationTransactionsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfTransactionsWithPaginationDto>> {
    return organizationTransactionsGetOrganizationTransactionsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * For each user get OrganizationTransactions with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationTransactionsGetOrganizationTransactionsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationTransactionsGetOrganizationTransactionsWithPagination(params: OrganizationTransactionsGetOrganizationTransactionsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfTransactionsWithPaginationDto> {
    return this.organizationTransactionsGetOrganizationTransactionsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfTransactionsWithPaginationDto>): CustomResultOfTransactionsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `organizationTransactionsGetResellerOrganizationTransactionWithPagination()` */
  static readonly OrganizationTransactionsGetResellerOrganizationTransactionWithPaginationPath = '/OrganizationTransactions/GetResellerOrganizationTransactionWithPagination';

  /**
   * Get Reseller Organization Transaction With Pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationTransactionsGetResellerOrganizationTransactionWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationTransactionsGetResellerOrganizationTransactionWithPagination$Response(params: OrganizationTransactionsGetResellerOrganizationTransactionWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfTransactionsWithPaginationDto>> {
    return organizationTransactionsGetResellerOrganizationTransactionWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Reseller Organization Transaction With Pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationTransactionsGetResellerOrganizationTransactionWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationTransactionsGetResellerOrganizationTransactionWithPagination(params: OrganizationTransactionsGetResellerOrganizationTransactionWithPagination$Params, context?: HttpContext): Observable<CustomResultOfTransactionsWithPaginationDto> {
    return this.organizationTransactionsGetResellerOrganizationTransactionWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfTransactionsWithPaginationDto>): CustomResultOfTransactionsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `organizationTransactionsGetOrganizationTransactionById()` */
  static readonly OrganizationTransactionsGetOrganizationTransactionByIdPath = '/OrganizationTransactions/GetOrganizationTransactionById';

  /**
   * Get OrganizationTransaction ById for edit.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationTransactionsGetOrganizationTransactionById()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationTransactionsGetOrganizationTransactionById$Response(params?: OrganizationTransactionsGetOrganizationTransactionById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetOrganizationTransactionByIdDto>> {
    return organizationTransactionsGetOrganizationTransactionById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get OrganizationTransaction ById for edit.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationTransactionsGetOrganizationTransactionById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationTransactionsGetOrganizationTransactionById(params?: OrganizationTransactionsGetOrganizationTransactionById$Params, context?: HttpContext): Observable<CustomResultOfGetOrganizationTransactionByIdDto> {
    return this.organizationTransactionsGetOrganizationTransactionById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetOrganizationTransactionByIdDto>): CustomResultOfGetOrganizationTransactionByIdDto => r.body)
    );
  }

  /** Path part for operation `organizationTransactionsGetOrganizationTransactionsAudit()` */
  static readonly OrganizationTransactionsGetOrganizationTransactionsAuditPath = '/OrganizationTransactions/GetOrganizationTransactionsAudit';

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationTransactionsGetOrganizationTransactionsAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationTransactionsGetOrganizationTransactionsAudit$Response(params: OrganizationTransactionsGetOrganizationTransactionsAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVmMongo>> {
    return organizationTransactionsGetOrganizationTransactionsAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationTransactionsGetOrganizationTransactionsAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationTransactionsGetOrganizationTransactionsAudit(params: OrganizationTransactionsGetOrganizationTransactionsAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVmMongo> {
    return this.organizationTransactionsGetOrganizationTransactionsAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVmMongo>): CustomResultOfAuditVmMongo => r.body)
    );
  }

  /** Path part for operation `organizationTransactionsGetOrganizationTransactionsByUserIdWithPagination()` */
  static readonly OrganizationTransactionsGetOrganizationTransactionsByUserIdWithPaginationPath = '/OrganizationTransactions/GetOrganizationTransactionsByUserIdWithPagination';

  /**
   * دریافت لیست تراکنش های کاربر با صفحه بندی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationTransactionsGetOrganizationTransactionsByUserIdWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationTransactionsGetOrganizationTransactionsByUserIdWithPagination$Response(params: OrganizationTransactionsGetOrganizationTransactionsByUserIdWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfTransactionsWithPaginationDto>> {
    return organizationTransactionsGetOrganizationTransactionsByUserIdWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست تراکنش های کاربر با صفحه بندی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationTransactionsGetOrganizationTransactionsByUserIdWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationTransactionsGetOrganizationTransactionsByUserIdWithPagination(params: OrganizationTransactionsGetOrganizationTransactionsByUserIdWithPagination$Params, context?: HttpContext): Observable<CustomResultOfTransactionsWithPaginationDto> {
    return this.organizationTransactionsGetOrganizationTransactionsByUserIdWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfTransactionsWithPaginationDto>): CustomResultOfTransactionsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `organizationTransactionsGetOrganizationTransactionsByOrganizationIdWithPagination()` */
  static readonly OrganizationTransactionsGetOrganizationTransactionsByOrganizationIdWithPaginationPath = '/OrganizationTransactions/GetOrganizationTransactionsByOrganizationIdWithPagination';

  /**
   * دریافت لیست تراکنش های سازمان با صفحه بندی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationTransactionsGetOrganizationTransactionsByOrganizationIdWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationTransactionsGetOrganizationTransactionsByOrganizationIdWithPagination$Response(params: OrganizationTransactionsGetOrganizationTransactionsByOrganizationIdWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfTransactionsWithPaginationDto>> {
    return organizationTransactionsGetOrganizationTransactionsByOrganizationIdWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست تراکنش های سازمان با صفحه بندی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationTransactionsGetOrganizationTransactionsByOrganizationIdWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationTransactionsGetOrganizationTransactionsByOrganizationIdWithPagination(params: OrganizationTransactionsGetOrganizationTransactionsByOrganizationIdWithPagination$Params, context?: HttpContext): Observable<CustomResultOfTransactionsWithPaginationDto> {
    return this.organizationTransactionsGetOrganizationTransactionsByOrganizationIdWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfTransactionsWithPaginationDto>): CustomResultOfTransactionsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `organizationTransactionsGetCurrentOrganizationLastLimitedTransactions()` */
  static readonly OrganizationTransactionsGetCurrentOrganizationLastLimitedTransactionsPath = '/OrganizationTransactions/GetCurrentOrganizationLastLimitedTransactions';

  /**
   * دریافت آخرین تراکنش های سازمان جاری.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationTransactionsGetCurrentOrganizationLastLimitedTransactions()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationTransactionsGetCurrentOrganizationLastLimitedTransactions$Response(params?: OrganizationTransactionsGetCurrentOrganizationLastLimitedTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LastLimitedTransactionDto>>> {
    return organizationTransactionsGetCurrentOrganizationLastLimitedTransactions(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آخرین تراکنش های سازمان جاری.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationTransactionsGetCurrentOrganizationLastLimitedTransactions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationTransactionsGetCurrentOrganizationLastLimitedTransactions(params?: OrganizationTransactionsGetCurrentOrganizationLastLimitedTransactions$Params, context?: HttpContext): Observable<Array<LastLimitedTransactionDto>> {
    return this.organizationTransactionsGetCurrentOrganizationLastLimitedTransactions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LastLimitedTransactionDto>>): Array<LastLimitedTransactionDto> => r.body)
    );
  }

  /** Path part for operation `organizationTransactionsGetCurrentUserLastLimitedTransactions()` */
  static readonly OrganizationTransactionsGetCurrentUserLastLimitedTransactionsPath = '/OrganizationTransactions/GetCurrentUserLastLimitedTransactions';

  /**
   * دریافت آخرین تراکنش های کاربر جاری.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationTransactionsGetCurrentUserLastLimitedTransactions()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationTransactionsGetCurrentUserLastLimitedTransactions$Response(params?: OrganizationTransactionsGetCurrentUserLastLimitedTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LastLimitedTransactionDto>>> {
    return organizationTransactionsGetCurrentUserLastLimitedTransactions(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت آخرین تراکنش های کاربر جاری.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationTransactionsGetCurrentUserLastLimitedTransactions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationTransactionsGetCurrentUserLastLimitedTransactions(params?: OrganizationTransactionsGetCurrentUserLastLimitedTransactions$Params, context?: HttpContext): Observable<Array<LastLimitedTransactionDto>> {
    return this.organizationTransactionsGetCurrentUserLastLimitedTransactions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LastLimitedTransactionDto>>): Array<LastLimitedTransactionDto> => r.body)
    );
  }

}
